export default __webpack_public_path__ + "static/media/driver.0c1b5428.svg";